import { t } from '@lingui/core/macro';
import { NoddiInput } from 'noddi-ui-web';

type Props = {
  /** Null unless payment options named a company and invoice is the method. */
  rule: { required: boolean } | null;
  value: string;
  onChange: (value: string) => void;
};

/** Invoice reference for a non-member company booking. Renders nothing otherwise. */
export const OrganizationCarInvoiceReference = ({ rule, value, onChange }: Props) => {
  if (!rule) {
    return null;
  }

  return (
    <NoddiInput
      name='invoice-reference'
      label={rule.required ? t`Invoice reference` : t`Invoice reference (optional)`}
      tooltip={t`A reference from the organization, such as an order number or a project. It is shown on the invoice so the organization can match this booking.`}
      maxLength={255}
      placeholder={rule.required ? t`Required` : undefined}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
